export default "__VITE_ASSET__1912f4b5__"